import React, { useEffect, useState, useRef } from 'react';
import Loader from '../../CustomComponents/Loader';
import { useDispatch, useSelector } from 'react-redux';
import HomeHeader from '../../CustomComponents/HomeHeader';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment';
import { withOidcSecure } from '@axa-fr/react-oidc';
import { addLineBreaks } from '../../../utils';
import HomeLayout from '../../Layout/HomeLayout';
import left_arrow_green from "../../../assets/images/left_arrow_green.png"
import { appTheme } from '../../../helpers/utils/Utils';
import TermsArrow from '../../../assets/images/terms_arrow.png'
import DynamicCard from '../../CustomComponents/DynamicComponent/DynamicCard.js';
import { GET_KUDZUPLUS_COVERAGE, STATUS_SUCCESS_CODE } from '../../../network/URLConstants.js';
import { retrieveData } from '../../../utils';
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from '../../../network/NetworkUtils.js';
import { CHECKING_CARD_CODE } from '../../../helpers/utils/Utils';
import { getUserMembership } from '../../../helpers/utils/Utils';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';


const NotificationDetails = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentDate = new Date();
  const minDate = new Date(currentDate);
  minDate.setMonth(currentDate.getMonth() - 6); // Minimum date is 6 months ago
  const { t } = useTranslation(); // Hook to access translation functions
  const cards = useSelector(state => JSON.parse(state.userCards));
  const transactionDetails = useSelector(state => JSON.parse(state.cancelTransactionDetails));
  const selectedItem = cards?.[0]
  const [isLoading, setIsLoading] = useState(false);
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue)

    useDocumentTitle(t('page_title_notification_details'));

  const styleAll = `font-hanken-grotesk  lg:text-[18px] md:text-[15px] sm:text-[14px] text-[16px] leading-[18px] font-[500] break-words text-[var(--text-clr-transactions)]`
  const styleAllMain = `font-hanken-grotesk  lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px] leading-[18px] font-[500] break-words text-[var(--text-clr-transactions)]`
  const styleAllthirdColumn = `mt-[42%] font-hanken-grotesk  lg:text-[20px] md:text-[15px] sm:text-[14px] text-[16px] leading-[18px] font-[500] break-words text-[var(--text-clr-transactions)]`
  const styleAllLableOne = `font-hanken-grotesk  lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px] leading-[18px] font-[500] break-words text-[var(--text-clr-transactions)]`
  const styleAllSubLableOne = `font-hanken-grotesk  lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px] leading-[18px] font-[500] break-words text-[#30BC89]`
  const styleAllLabletwo = `font-hanken-grotesk  lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px] leading-[18px] font-[500] break-words text-[var(--text-clr-transactions)]`
  const styleAllLablethree = `font-hanken-grotesk mt-12 lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px] leading-[18px] font-[500] break-words text-[#30BC89]`
  const [isShowDropdown, setIsShowDropdown] = useState(false);
  const [notifications, setNotifications] = useState(null);
  const [alerts, setAlerts] = useState(null);
  const [isUnReadAllActive, setIsUnReadAllActive] = useState(false);
  const [isReadAllActive, setIsReadAllActive] = useState(false);
  const accessTokenToApi = useSelector((state) => state.accessToken);
  const [cbkCoverageData, setCbkCoverageData] = useState(false);
  const [unpaidTransactionData, setUnpaidTransactionData] = useState(false);
  const [userDataPercentage, setUsedPercentageData] = useState(false);
  const [limit, setLimit] = useState('');
  const notificationItemSelect = useSelector(state => state.notificationsItem)
  const notificationsSelected = useSelector(state => state.notifications);
  const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
  const userMembershipData = getUserMembership(loggedResponse)
  const getBKPlusCoverage = async () => {
    if (cards[0]?.CardKey == undefined || cards[0]?.CardKey == null) {
      return;
    }
  
    setIsLoading(true);
  
    try {
      let url = GET_KUDZUPLUS_COVERAGE(cards.find((item) => (item.AccountTypeBit63 == CHECKING_CARD_CODE)).CardKey);
      const deviceId = await retrieveData('updatedDeviceId');
      const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
      const response = await GetRequest(url, headers);
      const responseObj = JSON.parse(response);
  
      if (responseObj?.ResponseCode == STATUS_SUCCESS_CODE) {
        const resData = responseObj?.Response;
        setCbkCoverageData(resData);
        setUnpaidTransactionData(Array.isArray(resData?.unPaidTransactions) ? resData.unPaidTransactions : []);
        const usedPercentage = (resData?.overdraftAmountUsed / resData?.overdraftLimit) * 100;
        setUsedPercentageData(usedPercentage);
        setLimit(resData?.overdraftLimit);
        // getRepaidTransactions()
      } else {
        const arrMessages = responseObj.Messages;
        const message = arrMessages[0];
        const displayText = message.DisplayText;
        // Handle/display error message if needed
      }
    } catch (error) {
      console.error("Error fetching BKPlus coverage:", error);
      
    } finally {
      setIsLoading(false);
    }
  };
   

       useEffect(() => {
        getBKPlusCoverage()
        }, [])
  
      const handleTermsClick = () =>{
        if (accessTokenToApi === undefined || accessTokenToApi == null) {
        return;
      }
      else {
         navigate('/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions', { state: { name: 'Covered by Kudzu Terms and Conditions', 
          url:
            userMembershipData?.membershipType === "Plus" ||
            userMembershipData?.membershipType === "Trial"
            ? "CoveredByKudzuPlusTerms"
            : "CoveredByKudzuTerms"
          , accType: 64, CardKey: cards?.[0]?.CardKey } });
      }
     }

    const addMoneyClick = () => {
       navigate('/AccountServices/Spending/TransferMoney') 
    }

    const handleClickCoveredBKudzu = () => {
      navigate('/Toolkit/ManageCoveredByKudzu', { state: { autoViewDetails: true } });
    };

const getHeaderText = () => {
  return (
    <>
      {(addLineBreaks(t('notification_heading')))}
    </>
  )
};


const addMoneyClickOne = () => {
  navigate('/notifications') 
}

const formatDateTime = (dateTimeString) => {
  const date = new Date(dateTimeString);
  const now = new Date();
  const diffMs = now - date; // Difference in milliseconds
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24)); // Convert to days

  const timeOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };
  const time = date.toLocaleTimeString('en-US', timeOptions).toUpperCase();

  if (diffDays === 0) {
    return `Today at ${time} EST`;
  } else if (diffDays === 1) {
    return `1 day ago`;
  } else if (diffDays > 1) {
    return `${diffDays} days ago`;
  } else {
    // Handle future dates or errors (optional)
    return `Today at ${time} EST`; // Fallback for future dates or invalid cases
  }
};

  const children = () => {
    return (
        <>
        <div className='md:pb-[9rem] pb-[5rem] mt-6 sm:px-0 px-4'>
          <div className='flex flex-row sm:items-center justify-between w-full'>

            <div className={`lg:w-1/4 md:w-[30%] sm:w-1/2 w-[57%] ${styleAll} `}>
              <p>{""}</p>
              <p className='block sm:hidden font-hanken-grotesk text-[#262B3A] lg:text-[13px] md:text-[13px] sm:text-[13px] text-[14px] font-[400] mt-1 opacity-[50%]'>{""}</p>
            </div>
            <div className={`hidden sm:block sm:w-1/4 text-center ${styleAll}`}>
              <p>{""}</p>
            </div>
            <div className={`sm:w-1/5`}>
              <p className={`flex justify-end mb-8 sm:mb-0 font-hanken-grotesk lg:text-[18px] md:text-[15px] sm:text-[14px] text-[16px] leading-[18px] font-[500] break-words `}
              >
                {""}</p>
            </div>
          </div>
          <div class="flex justify-center flex-col items-center">
            <div className="md:w-[75%] w-full sm:mt-14 mt-8">
            <p className={`mb-4 sm:mb-0 ${styleAllMain}`} dangerouslySetInnerHTML={{ __html: notificationsSelected.length > 0 ? notificationsSelected[0].Content.replace(/href="[^"]*"/, 'href="#"').replace('<a', '<a style="color: #94C3E8; pointer-events: none; cursor: default;"') : '' }} />
              <div className="flex items-center space-x-4 text-sm mt-9 text-[#2C364D]">
                <span className="bg-[#2C3C5A] text-[#94C3E8] text-[12px] px-3 py-1 rounded-full font-semibold min-w-[70px] text-center">
                  Important
                </span>
                
                <p className={`mb-4 sm:mb-0 ${styleAllMain}`}>
                     {notificationsSelected.length > 0 && (
                      <span className="text-[#94C3E8] font-semibold text-[12px]">
                       {formatDateTime(notificationsSelected[0].CreatedDateTime)}
                     </span>
                  )}
               </p>
             
              </div>
            </div>
            <div class="sm:flex md:w-[75%] w-full sm:mt-14 mt-8">
              <div className='sm:w-[50%]'>
                <p className='mb-8 font-hanken-grotesk text-[#94C3E8] uppercase lg:text-[10px] md:text-[10px] sm:text-[11px] text-[10px] font-[600] tracking-[2px]'>{t('Coverage Details')}</p>
                <p className={`mb-8 sm:mb-0 ${styleAllLableOne}`}>
                  <span>${cbkCoverageData.overdraftAmountUsed}</span>
                  <span className="ml-4">Covered</span>
                </p>
                <p className={`mb-8 pt-2 sm:mb-0 ${styleAllSubLableOne}`}>
                  <span>${cbkCoverageData.overdraftLimit}</span>
                  <span className="ml-4">Available</span>
                </p>
              </div>
              {Array.isArray(unpaidTransactionData) && unpaidTransactionData.length > 0 &&
               unpaidTransactionData.map((item, index) => (
                <>
              <div className='sm:w-[30%]'>
                <p className='mb-8 font-hanken-grotesk text-[#94C3E8] uppercase lg:text-[10px] md:text-[10px] sm:text-[11px] text-[10px] font-[600] tracking-[2px]'>{t('CURRENT ACTIVITY')}</p>
                <p className={`mb-8 sm:mb-0 ${styleAllLabletwo}`}
                >{item.Description}</p>
                     <span className="text-[14px]  text-[#779CE5]">{new Date(item.TransactionDate).toLocaleDateString('en-US', {
                       month: 'long',
                       day: 'numeric'
                     })}</span>
              </div>
              <div className='sm:w-[20%]'>
                <p className=' font-hanken-grotesk text-[#94C3E8] uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px]'>{t('')}</p>
                <p className={`sm:mb-0 ${styleAllLablethree}`}
                >-{item.Amount }</p>
              </div></>
             ))}
           </div> 

            <div class="md:w-[75%] w-full sm:mt-14 mt-2">
              <>
                <button
                  onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); addMoneyClick() } }}
                  className={`w-full mt-8 lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] leading-[16px] border-[var(--modal-btn-color)] border-[2.5px] text-[var(--cbk-transaction-bt-clr)]`}
                  onClick={(event) => { event.target.style.opacity = 0.8; setTimeout(() => { event.target.style.opacity = 1; }, 200); addMoneyClick() }}>
                  {t('addMoneyTittle')}
                </button>
                {kudzuPlusTrue && <button
                  onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); } }}
                  className={`w-full mt-8 lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] font-hanken-grotesk font-bold lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] leading-[16px] border-[var(--modal-btn-color)] border-[2.5px] text-[var(--cbk-transaction-bt-clr)]`}
                  onClick={(event) => { event.target.style.opacity = 0.8; setTimeout(() => { event.target.style.opacity = 1; }, 200); handleClickCoveredBKudzu() }}>
                  {t('view_cbk+')}
                </button>}
              </>
              <p className='mt-9 sm:my-9  text-[13px] font-hanken-grotesk 
                                                    leading-[18px] font-[400]  text-[#94C3E8]'>
                {/* {addLineBreaks(t("cbk_transaction_updated_text_update_notifications"))}   */}
                {t("cbk_transaction_updated_text_update_notifications")}  
                <span className="underline cursor-pointer" onClick={handleTermsClick}>{t('Redirect_terms_and_conditions_cbk')}</span>{t('Remaining_content_cbk')}
              </p>

              <div className=" flex justify-start my-16">
                <p className=' font-semibold
                               text-[12px] leading-[20px] md:font-[700] 
                               md:text-[16px] md:leading-[16px] text-[#ffffff]
                               cursor-pointer' onClick={addMoneyClickOne}>
                                {t("Back")}
                               </p>
              </div>
            </div>

                 
                </div>
              </div>
        </>
    )
}




   const Headingcom = () => {
        return (
            <div className="relative">
                <div className="flex flex-row justify-between mx-10 my-6 md:m-10">
                <div className="flex flex-row gap-2 items-center ">
                        <p className='font-hanken-grotesk font-[600] text-[var(--notificationItem-color)] text-[16px] leading-[26px] sm:text-[15px] sm:leading-[23px] md:font-[500] md:text-[26px] md:leading-[36px]'>{t("notifications")}</p>

                    </div>
                    <div className="my-auto cursor-pointer">
                        <img src={appThemeData.threeDots} alt="Three Dots" onClick={() => setIsShowDropdown(prev => !prev)} />

                    </div>
                </div>
            </div>
        )
    }




  return (
  
    <HomeLayout>
    <HomeHeader heading={getHeaderText()} isHeaderCaption={true} />
    <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight '>

        <DynamicCard
            headerContent={Headingcom()}
            cardHeight='h-[900px]'
            cardContent={children()}
            footerHeight={'h-[0px]'}
        />
    </div>

    {isLoading && <Loader />}


</HomeLayout >
  );
};

export default withOidcSecure(NotificationDetails);
